import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import ProductPage from "@/pages/ProductPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import useMetaPixel from "@/hooks/useMetaPixel";

function AppRoutes() {
  useMetaPixel();
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/products/:slug" element={<ProductPage />} />
      <Route path="/admin/login" element={<Login />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
